import { DonutChart as MantineDonutChart } from '@mantine/charts'
import { Flex, List } from '@mantine/core'

import { TYPE_GROUP } from '@/components/@Shared/DonutChart/DonutChart.config'
import {
  type DonutChartProps,
  isTypeGroupKey,
} from '@/components/@Shared/DonutChart/DonutChart.types'
import { DonutChartTooltip } from '@/components/@Shared/DonutChart/partials/DonutChartTooltip/DonutChartTooltip'
import { Text } from '@/components/Text/Text'

import classes from './DonutChart.module.css'

export function DonutChart({
  bigger = false,
  data,
  extended = false,
  withTooltip = false,
  ...props
}: DonutChartProps) {
  return (
    <>
      <MantineDonutChart
        className={bigger ? classes.bigger : classes.root}
        data={data}
        mb={36}
        mt={25}
        mx="auto"
        size={bigger ? 256 : 183}
        strokeWidth={0}
        thickness={bigger ? 70 : 50}
        tooltipProps={{
          content: ({ payload }) => <DonutChartTooltip payload={payload} />,
        }}
        withTooltip={withTooltip}
        {...props}
      />

      {extended && (
        <List className={classes.legend}>
          {data.map(item => (
            <List.Item key={item.name}>
              <Flex align="center" gap={8}>
                <span
                  className={classes.dot}
                  style={{
                    backgroundColor: item.color,
                  }}
                />

                {isTypeGroupKey(item.name) && (
                  <Text variant="body_2_black">
                    {TYPE_GROUP[item.name].label}
                  </Text>
                )}
              </Flex>
            </List.Item>
          ))}
        </List>
      )}
    </>
  )
}
